import type { MainRenderer } from './mainRenderer';

export const loadMainRenderer = async (): Promise<MainRenderer> => {
  const { mainRenderer } = await import(/* webpackChunkName: "3-render-mainrenderer" */ './mainRenderer');

  return mainRenderer;
};
